<template>
  <div
    :class="$blockClass(blockClass)"
    class="testimonial text-center grid no-row-gap"
  >
    <div
      v-if="eyebrowCopy"
      :class="$blockClass(blockClass, 'eyebrow')"
      class="testimonial__eyebrow col xs4"
    >
      <eyebrow
        :enable-bullet="eyebrowBullet"
        :text="eyebrowCopy"
      />
    </div>

    <div
      v-if="quote"
      :class="$blockClass(blockClass, 'quote')"
      class="testimonial__quote col xs4 l3-10"
    >
      <highlighter-title
        :highlighter-color="highlighterColor"
        :highlighter-copy="$cleanRTE(quote)"
        custom-element="h6"
        highlighter-size="h6"
      />
    </div>

    <div
      v-if="author"
      :class="$blockClass(blockClass, 'author')"
      class="testimonial__author col xs4"
    >
      <p
        class="body-1"
        v-text="author"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: testimonial (testimonial)
 * -----------------------------------------------------------------------------
 * A quote with author.
 * A sub-component of a testimonial carousel.
 *
 * @param {String} blockClass - Custom class to apply to all elements.
 * @param {String} eyebrowCopy - The copy above the quote.
 * @param {Boolean} eyebrowBullet - Show indicator next to eyebrow.
 * @param {String} quote - The rich text to display.
 * @param {String} author - The author of the quote.
 */

export default {
  name: 'Testimonial',

  components: {},

  props: {
    blockClass: {
      type: String,
      default: '',
    },
    eyebrowCopy: {
      type: String,
      default: '',
    },
    eyebrowBullet: {
      type: Boolean,
      default: false,
    },
    quote: {
      type: String,
      default: '',
    },
    author: {
      type: String,
      default: '',
    },
    highlighterColor: {
      type: String,
      default: '',
    },
  },

  computed: {},

  methods: {},
}
</script>

<style lang="scss">
@import './testimonial';
</style>
